<script>
  import AddressStore from './stores.js';
  import Add from './Add.svelte';
  import Delete from './Delete.svelte';
</script>

<main>
  <Add />
  <div class="flex justify-center flex-col gap-4">
  {#if $AddressStore}
    <div class="p-6">
      {#each Object.entries($AddressStore) as [key, value], index (key)}
        <div class="block p-6 rounded-lg shadow-lg bg-white max-w-sm">
          <h2 class="text-gray-900 text-xl leading-tight font-medium mb-2"> Provider: {value.provider} </h2>
          <p class="text-gray-700 text-base mb-4"> Range: {value.range} </p>
          {#if value.provider === "Amazon" }
            <p class="text-gray-700 text-base mb-4"> Service: {value.service} </p>
            <p class="text-gray-700 text-base mb-4"> Network Border Group: {value.network_border_group} </p>
            <p class="text-gray-700 text-base mb-4"> Region: {value.region} </p>
          {:else if value.provider === "Google Cloud" }
            <p class="text-gray-700 text-base mb-4"> Service: {value.service} </p>
            <p class="text-gray-700 text-base mb-4"> Scope: {value.scope} </p>
          {:else if value.provider === "Digital Ocean"}
            <p class="text-gray-700 text-base mb-4"> City: {value.city} </p>
            <p class="text-gray-700 text-base mb-4"> Country City Code: {value.country_city_code} </p>
            <p class="text-gray-700 text-base mb-4"> Country Code: {value.country_code} </p>
          {/if}
          {#each [...value.seen_ips] as ip}
            <p class="text-gray-700 text-base mb-4"> {ip} </p>
          {/each}
          <p class="text-gray-700 text-base mb-4"> Count: {value.count} </p>
          <Delete address={value.range}/>
        </div>
      {/each}
    </div>
  {/if}
  </div>
</main>

<style global lang="postcss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
</style>
